export default "__VITE_ASSET__DKO4fBa0__"